import MUIAutocomplete from "@mui/material/Autocomplete";

const Autocomplete = MUIAutocomplete;

export default Autocomplete;
